import type { Messages } from "./messages";
import i18next, { initI18nPromise } from "./i18n";

export type Locale = "en" | "id";

export const defaultLocale: Locale = "en";

export const SUPPORTED_LOCALES: Locale[] = ["en", "id"];

export function resolveLocale(locale: string): Locale {
  const key = (locale || defaultLocale).toLowerCase().split("-")[0];
  return SUPPORTED_LOCALES.includes(key as Locale)
    ? (key as Locale)
    : defaultLocale;
}

export function getLocaleFromACULContext(): Locale {
  if (typeof window === "undefined") return defaultLocale;
  const ctx = (
    window as {
      universal_login_context?: { transaction?: { locale?: string } };
    }
  ).universal_login_context;
  const raw = ctx?.transaction?.locale;
  return raw && SUPPORTED_LOCALES.includes(raw as Locale)
    ? (raw as Locale)
    : defaultLocale;
}

export function getMessages(locale: string): Messages {
  const lng = resolveLocale(locale);
  const bundle = i18next.getResourceBundle(lng, "translation") as
    | Messages
    | undefined;
  if (bundle) return bundle;
  return i18next.getResourceBundle(defaultLocale, "translation") as Messages;
}

export { i18next, initI18nPromise };
